import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { ReactComponent as Inspiration } from './assets/inspiration.svg';

const InspirationIcon = styled(Inspiration)`
  stroke: ${themeStyle.varInkMain};
`;

export default InspirationIcon;
